import * as t from 'io-ts'
import { nullable } from 'lib/request'

export const TUserStatus = t.union([
  t.literal('active'),
  t.literal('inactive'),
  t.literal('pending'),
])

export const TUser = t.strict({
  email: t.string,
  fullName: t.string,
  userId: t.string,
  avatarUrl: nullable(t.string),
})

export type User = t.TypeOf<typeof TUser>

export const TRoleType = t.union([
  t.literal('admin'),
  t.literal('user'),
  t.literal('member'),
])

export const TMyProfile = t.intersection([
  TUser,
  t.strict({
    status: TUserStatus,
    role: TRoleType,
    awaitingConfirmationEmail: nullable(t.string),

    // only users with role "user" can have plan, otherwise returns null
    plan: nullable(
      t.strict({
        planId: t.string,
        name: t.string,
      }),
    ),
  }),
])

export type MyProfile = t.TypeOf<typeof TMyProfile>
